
import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './MultiCardModule.css';
import { Button, ReviewsCard, Section } from '../../importCL';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';

interface IMultiCardModuleProps extends MappedComponentProperties {
    headlineText?: string;
    subheading?: string;
    showBorder?: boolean;
    imgWidth?: string;
    imgHeight?: string;
    imgAlign?: string;
    backgroundColor?: string;
    cardsPerRow?: string;
    cards?: {
        headlineText?: string;
        descriptionText?: string;
        imagePath?: string;
        imageAltText?: string;
        link?: string;
        linkText?: string;
    }[];
}

export const MultiCardModuleEditConfig = {
    emptyLabel: 'Multi Card Module',
    isEmpty: (props: PropsWithChildren<IMultiCardModuleProps>) => {
        return !props || !props.headlineText;
    },
};

const BACKGROUND_COLOR_OPTIONS = {
    purple: { backgroundColor: 'purple', titleColor: 'text-white' },
    blue: { backgroundColor: 'blue', titleColor: 'text-white' },
    lightGray: { backgroundColor: 'light-grey', titleColor: 'text-grey-tundora' },
    white: { backgroundColor: 'white', titleColor: 'text-grey-tundora' },
} as const;

const MultiCardModule = (props: PropsWithChildren<IMultiCardModuleProps>): JSX.Element => {
    const sectionStyles = BACKGROUND_COLOR_OPTIONS[props?.backgroundColor ?? 'white'];
    const darkMode = props.backgroundColor === 'blue' || props.backgroundColor === 'purple';
    
    const pxToRem = (pxValue: string): string => {
        return (Number(pxValue) / 16).toString();
    }

    return (
        <Section className='MultiCardModule'
            containerClass='MultiCardModule__sectionContainer'
            bgColor={sectionStyles.backgroundColor} 
            titleClass={`${sectionStyles.titleColor} ${darkMode? '!border-white' : ''}`}
            horizontalTitle
            title={props.headlineText ? transformHTMLParserLinks(props.headlineText):  ''}
            spanTitle={props.subheading ? transformHTMLParserLinks(props.subheading) : ''} >
            <div className={`MultiCardModule__cards grid justify-center ${props.showBorder ? 'gap-[1.5rem]' : 'gap-x-[4.5rem]'} ${props.cardsPerRow && `MultiCardModule__cards--${props.cardsPerRow}`}`}>
                {props.cards && props.cards.slice(0, 6).map((card, index) => (
                    <ReviewsCard 
                        key={index}
                        bgColor="none"
                        cardVariant='news'
                        className={`${props.showBorder ? '' : '!px-0'}`}
                        borderSettings={{
                            borderColor: darkMode ? 'white' : 'grey-tundora-50',
                            borderRadiusMedium: false,
                            display: props.showBorder ? true : false,
                            squareBorder: true,
                        }}
                        headLineSettings={{
                            textClass: `text-lg font-bold mb-0 ${darkMode ? 'text-white ' : ''}`
                        }}
                        bodyTextContainerClass = {darkMode? 'ReviewsCardBody--darkMode': ''}
                        topElement={
                            <div className={`flex ${props.imgAlign}`}>
                                <img 
                                    className='mb-6' 
                                    src={card.imagePath as string} 
                                    alt={card.imageAltText ?? 'image'} 
								    style={{ width: `${pxToRem(props.imgWidth)}rem`, height: `${pxToRem(props.imgHeight)}rem`}}
                                    />
                            </div>
                        }
                        reviewContent={{
                            headLineText: (transformHTMLParserLinks(card.headlineText ?? '')),
                            bodyText: (transformHTMLParserLinks(card.descriptionText ?? '')),
                        }}>
                        {card.linkText && card.link &&
                            <Button className='!p-0 !text-base underline !mb-0'
                                variant= {darkMode ? 'link-light' : 'link'}
                                href={card.link}>
                                {transformHTMLParserLinks(card.linkText)}
                            </Button>
                        }
                    </ReviewsCard>
                ))}
            </div>
        </Section>
    );
};

export default MultiCardModule;
        